import React, { useContext, useEffect, useState } from "react";
import CartItems from "./CartItem";
import { CartContext } from "./ContextProvider";
import Loader from "../common/Loader";
import './carts.css'
import OrderSuccess from "../Payment/orderSuccess";

function CartPage() {
  const { totalPrice, cartItems,initialLoading,orderSuccess } = useContext(CartContext);
  const [loading,setLoading] = useState(true)

  useEffect(()=>{
    setTimeout(()=>{setLoading(false)},800)
  })

  return (
    <div className="Cart">

      { initialLoading || loading ? <Loader></Loader>: cartItems.length === 0 ? (
        <div className="noCart"><img src="../../assets/no-cart-items.png" /></div>

      ) : (
        <>
          <CartItems />

        </>
      )}
    </div>
  );
}



export default CartPage;